<template>
  <div class="register" style="height: 100%; padding-bottom: 2rem">
    <a @click="$router.go(-1)" class="cursor-pointer" title="Go back">
      <v-icon large>arrow_back</v-icon>
    </a>
    <v-form style="position: relative" ref="form">
      <v-card max-width="500" class="mx-auto">
        <v-app-bar dark color="primary">
          <v-toolbar-title>
            <translate>Register New User</translate>
          </v-toolbar-title>
        </v-app-bar>
        <div class="mt-3 pl-4"><ErrorMessages :error="error" /></div>
        <v-container class="pa-6 px-4 py-1 pb-0" fluid grid-list-md>
          <v-layout>
            <v-flex sm12 md6>
              <v-text-field
                v-model="name"
                :label="$gettext('First Name') + ' *'"
                placeholder=""
                required
                :rules="[(v) => !!v || 'This field is required']"
              ></v-text-field>
            </v-flex>
            <v-flex sm12 md6>
              <v-text-field
                v-model="lastName"
                placeholder=""
                :label="$gettext('Last Name') + ' *'"
                required
                :rules="[(v) => !!v || 'This field is required']"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex sm12 md6>
              <v-autocomplete
                :label="$gettext('Country') + '*'"
                :items="$store.state.i18n.translations[this.$store.state.i18n.locale].country"
                v-model="country"
                item-text="countryName"
                item-value="countryShortCode"
                :rules="[(v) => !!v || 'This field is required']"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm12 md6 v-if="$store.state.auth.registration.isRegionSchemePresent">
              <v-autocomplete
                :label="$gettext('Region') + '*'"
                :items="regions"
                v-model="region"
                item-text="name"
                item-value="shortCode"
                :rules="[(v) => !!v || 'This field is required']"
                required
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex sm8>
              <v-text-field
                v-model="organizationId"
                placeholder=""
                :label="$gettext('Organization Id') + '*'"
                :disabled="invitationMode"
                required
                :rules="[(v) => !!v || 'This field is required']"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                v-model="organizationScheme"
                placeholder=""
                :label="$gettext('Organization Scheme') + '*'"
                required
                :disabled="invitationMode"
                :rules="[(v) => !!v || 'This field is required']"
                :items="invitationMode ? [organizationScheme] : schemesToChoose"
              >
                <template #append-outer v-if="country && !countrySchemes[country]">
                  <v-menu bottom max-width="250" color="secondary" open-on-hover="" offset-y="">
                    <template #activator="{ on }">
                      <v-icon size="18" v-on="on" color="info">mdi-information-outline</v-icon>
                    </template>
                    <p class="pa-2 ma-0 secondary white--text" style="font-size: 0.8rem">
                      Currently, the organization scheme of your country is not supported. Please
                      contact us via this
                      <a
                        class="white--text"
                        target="_blank"
                        rel="noreferrer noopener"
                        href="https://form.asana.com/?hash=826303eb481d98051b382b927fb646c9f01382db4cdd90bd27edf644959c69b6&id=1177823674542536"
                        >form</a
                      >, so we could update this setting.
                    </p>
                  </v-menu>
                </template>
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex sm12>
              <v-text-field
                v-model="email"
                placeholder=""
                :label="$gettext('Email') + '*'"
                required
                :disabled="invitationMode"
                :readonly="isOrganAndRoleShown && $route.query.email"
                :rules="[
                  (v) => !!v || 'This field is required',
                  (v) => $store.state.regexps.email.test(v) || 'This is not valid email',
                ]"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex sm12>
              <v-text-field
                v-model="password"
                placeholder=""
                :append-icon="showPass ? 'visibility' : 'visibility_off'"
                :type="showPass ? 'text' : 'password'"
                :label="$gettext('Password') + '*'"
                required
                :rules="[(v) => !!v || 'This field is required']"
                @click:append="showPass = !showPass"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <div class="pb-2">
            <ul class="password-requirements">
              <li
                :style="{
                  color: password.length >= 8 ? '#bdbbb9' : '',
                }"
              >
                <span
                  :style="{
                    background: password.length >= 8 ? '#bdbbb9' : '#007c89',
                  }"
                ></span>
                8 characters minimum
              </li>
            </ul>
          </div>
          <v-layout>
            <v-flex sm12>
              <v-text-field
                v-model="repeatPassword"
                placeholder=""
                :append-icon="showForgotPass ? 'visibility' : 'visibility_off'"
                :type="showForgotPass ? 'text' : 'password'"
                :rules="[
                  (v) => !!v || 'This field is required',
                  (v) => v === password || 'Passwords must be the same',
                ]"
                :label="$gettext('Repeat Password') + '*'"
                required
                @click:append="showForgotPass = !showForgotPass"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <!-- <v-layout>
                        <v-flex sm12 md6>
                            <v-autocomplete
                                :label="$gettext('Country') + ' *'"
                                :items="$store.state.i18n.translations[this.$store.state.i18n.locale].country"
                                :error-messages="countryErrors"
                                v-model="country"
                                @input="$v.country.$touch()"
                                @blur="$v.country.$touch()"
                                item-text="countryName"
                                item-value="countryShortCode"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex sm12 md6>
                            <v-autocomplete
                                :label="$gettext('Region') + ' *'"
                                :items="regions"
                                v-model="region"
                                :error-messages="regionErrors"
                                @input="$v.region.$touch()"
                                @blur="$v.region.$touch()"
                                item-text="name"
                                item-value="name"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>-->
          <v-layout v-if="isOrganAndRoleShown">
            <v-flex sm12 v-if="$route.query.org_id">
              <v-text-field
                v-model="organizationId"
                :value="organizationId"
                :label="$gettext('Organization ID')"
                required
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="isOrganAndRoleShown">
            <v-flex md12 v-if="$route.query.role">
              <v-select
                v-model="role"
                :items="roles"
                :label="$gettext('Role') + ' *'"
                required
                readonly
                @change="$v.role.$touch()"
                @blur="$v.role.$touch()"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions class="pb-6 pr-6">
          <v-spacer></v-spacer>
          <v-btn text @click="$router.go(-1)"> <translate>CANCEL</translate> </v-btn>&nbsp; &nbsp;
          <v-btn @click="submit" color="primary" :loading="loading">
            <translate>SUBMIT</translate>
          </v-btn>
        </v-card-actions>
      </v-card>
      <div class="d-flex justify-center mt-3">
        <router-link :to="{ name: 'login' }" v-translate class="login-link">Login</router-link>
      </div>
    </v-form>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import { mask } from 'vue-the-mask'
import identifiers from '@/assets/data/identifierScheme'
import countryJson from '@/assets/data/countryJson.json'

import 'intl-tel-input/build/css/intlTelInput.css'
import phoneNumberMixin from '@/mixins/phoneNumberMixin'
import ErrorHandler from '@/utils/ErrorHandler'
import { getOrganizationInvitation } from '@/services/apiCalls/profile/organization'

const $registerUser = {
  name: 'Register',

  directives: {
    mask,
  },

  mixins: [phoneNumberMixin],

  data: () => ({
    role: false,
    showPass: false,
    showForgotPass: false,
    checkbox: false,
    error: '',
    loading: false,
    regions: [],
    repeatPassword: '',
    // roles: ['administrator', 'publisher', 'member'],
    invitationMode: false,
    invitation: null,
  }),

  async created() {
    this.handleDefaultCountry()

    if (this.$route.query.id) {
      await this.getInvitation();
    }
  },

  watch: {
    defaultCountry(value) {
      this.country = value.toUpperCase()
    },
    country(newValue) {
      const countryList = this.$store.state.i18n.translations[this.$store.state.i18n.locale].country

      const country = countryList.find((country) => country.countryShortCode === newValue)

      this.regions = country.regions

      this.$nextTick(() => {
        if (this.country) {
          if (
            this.countrySchemes[this.country] &&
            this.regions &&
            this.regions.length &&
            this.countrySchemes[this.country].regions.some((regionSchema) => {
              return this.regions.some((el) => regionSchema === `${this.country}-${el.shortCode}`)
            })
          ) {
            this.$store.commit('auth/setRegionSchemePresence', true)
          } else {
            this.$store.commit('auth/setRegionSchemePresence', false)
          }
        }
      })
    },
    schemesToChoose(value) {
      if (value.length === 1) {
        this.organizationScheme = value[0]
      }
    },
  },

  computed: {
    countrySchemes() {
      const items = {}

      Object.keys(countryJson).forEach((key) => {
        items[key] = {}
        items[key].country = countryJson[key].schemes
          .filter((el) => el.quality >= 60)
          .map((el) => el.code)
        items[key].regions = countryJson[key].subnationalCoverage

        if (!items[key].country.length) {
          delete items[key]
        }
      })

      return items
    },
    schemesToChoose() {
      if (this.country && !this.region && this.countrySchemes[this.country]) {
        return this.countrySchemes[this.country].country
      } else if (
        this.country &&
        this.region &&
        this.countrySchemes[this.country] &&
        this.countrySchemes[this.country].regions
      ) {
        const regionScheme = this.countrySchemes[this.country].regions.filter(
          (el) => el === `${this.country + '-' + this.region}`,
        )
        return (regionScheme.length && regionScheme) || this.countrySchemes[this.country].country
      } else {
        return ['XE-NONE']
      }
    },
    organizationId: {
      get() {
        return this.$store.state.auth.registration.userInfo.organizationId
      },
      set(value) {
        this.$store.commit('auth/setOrganizationId', value)
      },
    },
    organizationScheme: {
      get() {
        return this.$store.state.auth.registration.userInfo.organizationScheme
      },
      set(value) {
        this.$store.commit('auth/setOrganizationScheme', value)
      },
    },
    region: {
      get() {
        return this.$store.state.auth.registration.userInfo.region
      },
      set(value) {
        this.$store.commit('auth/setRegion', value)
      },
    },
    country: {
      get() {
        return this.$store.state.auth.registration.userInfo.country
      },
      set(value) {
        this.$store.commit('auth/setCountry', value)
      },
    },
    name: {
      get() {
        return this.$store.state.auth.registration.userInfo.name
      },
      set(value) {
        this.$store.commit('auth/setUserName', value)
      },
    },
    lastName: {
      get() {
        return this.$store.state.auth.registration.userInfo.lastName
      },
      set(value) {
        this.$store.commit('auth/setUserLastName', value)
      },
    },
    email: {
      get() {
        return this.$store.state.auth.registration.userInfo.email
      },
      set(value) {
        this.$store.commit('auth/setUserEmail', value)
      },
    },
    password: {
      get() {
        return this.$store.state.auth.registration.userInfo.password
      },
      set(value) {
        this.$store.commit('auth/setUserPassword', value)
      },
    },
    formattedIdentifiers() {
      return identifiers.map((id) => id.code)
    },
    formattedOrgId() {
      return this.organizationScheme + '-' + this.organizationId
    },
    isOrganAndRoleShown() {
      return !!Object.keys(this.$route.query).length
    },
    showLogin() {
      return localStorage.getItem('authenticated') !== true
    },
  },

  methods: {
    async getInvitation() {
      try {
        this.$store.commit('spinner', true);
        const { data } = await getOrganizationInvitation(this.$route.query.id);
        const invitation = data.getOrganizationInvitation;
        if (invitation.status === 'pending') {
          this.invitation = invitation;
          this.invitationMode = true;
          this.email = invitation.email;
          this.organizationId = invitation.organizationId.split('-').pop();
          this.organizationScheme = invitation.organizationId.replace(/-[^-]*$/gm, '');
        }
      } catch (e) {
        ErrorHandler(e, this)
      } finally {
        this.$store.commit('spinner', false);
      }
    },
    // checkOrgatizationPresence() {
    //     if (this.organizationId && this.organizationScheme) {
    //         Profile.organization
    //             .getOrganization(this.formattedOrgId)
    //             .then(res => {
    //                 if (res.data.getOrganization) {
    //                     this.nameOfCreatedOrganization =
    //                         res.data.getOrganization.name
    //                 }
    //             })
    //             .catch(err => console.log(err))
    //     }
    //     return
    // },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.error = ''
        const clientMetadata = {
          domain: location.host
        };
        if (this.invitationMode) {
          clientMetadata.invitationId = this.invitation.mpID;
        }
        Auth.signUp({
          username: this.email,
          password: this.password,
          attributes: {
            email: this.email,
            given_name: this.name,
            family_name: this.lastName,
            'custom:cell_phone': '',
            'custom:org_ids': this.formattedOrgId,
          },
          clientMetadata,
        })
          .then(() => {
            this.loading = false
            // if (!data.userConfirmed) {
            //     AmplifyEventBus.$emit('authState', 'confirmSignUp')
            // } else {
            //     AmplifyEventBus.$emit('authState', 'signIn')
            // }
            this.$router.push({ name: 'confirmation' })
          })
          .catch((err) => {
            if (
              err &&
              err.message.includes('does not exist') &&
              err.message.includes('Organization')
            ) {
              this.loading = false
              this.$router.push({
                name: 'registerOrganization',
              })
            } else {
              this.error = err && err.message
              this.loading = false
            }
          })
      }
    },
    handleQueryUserPresence() {
      if (Object.keys(this.$route.query).length) {
        this.organizationId = this.$route.query.org_id
        this.id = this.$route.query.id
        this.select = this.$route.query.role
        this.name = this.$route.query.first_name
        this.lastName = this.$route.query.last_name
        this.role = this.$route.query.role
        this.email = this.$route.query.email
      }
    },
  },

  // watch: {
  //     country(newValue) {
  //         const country = this.$_.findWhere(
  //             this.$store.state.i18n.translations[
  //                 this.$store.state.i18n.locale
  //             ].country,
  //             {
  //                 countryShortCode: newValue
  //             }
  //         )
  //         this.regions = country.regions
  //     }
  // }
}
window.$registerUser = $registerUser
export default $registerUser
</script>

<style scoped lang="scss">
.register {
  padding: 20px;
}
.login-link-block {
  position: relative;
  display: inline-block;
  left: 50%;
  bottom: -30px;
  transform: translateX(-50%);
}
.password-requirements {
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    display: flex;
    align-items: center;
    color: rgb(36, 28, 21);
    font-size: 0.8rem;
    span {
      &:first-child {
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        margin-right: 0.65rem;
        display: inline-block;
      }
    }
  }
}
.phone-input {
  &:focus-within {
    label {
      color: #1976d2;
    }
  }

  div {
    position: relative;

    label {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.54);
    }
    input {
      width: 100%;
      border-bottom: 2px solid #c3c3c3;
      transition: 0.25s linear;
      outline: 2px solid transparent;
      // &:focus {
      //     border-bottom-color: #1976d2;
      // }
    }

    .focus-ripple {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 2px;
      background-color: #1976d2;
      transition: 0.4s;
    }
  }

  &:focus-within .focus-ripple {
    width: 100%;
    transition: 0.4s;
    left: 0;
  }
}
</style>
